import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs';
import { Type2Model } from '../../models';
import { CustomTypeService, SettingsService } from '../../services';

@Component({
    selector: 'app-custom-type-create',
    templateUrl: './custom-type-create.component.html',
    styleUrls: ['./custom-type-create.component.scss', '../layout/layout.component.scss']
})
export class CustomTypeCreateComponent implements OnInit {
    model: any;
    public showSpinner: boolean = false;
    constructor(private customTypeService: CustomTypeService,
        private route: ActivatedRoute,
        private toastr: ToastsManager,
        private settingService: SettingsService,
        public activeModal: NgbActiveModal,
        private router: Router) { }
    type2: string = "Type 2";
    ngOnInit() {
        this.model = new Type2Model();
        this.loadSetting();
    }

    public saveChanges(): void {
        this.showSpinner = true;
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.model.AccountId = currentUser.accountId;
        var SiteId = +localStorage.getItem('IncidentcurrentSiteId');

        this.model.SiteId = SiteId;

        this.customTypeService.saveCustomType(this.model)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response) => {

                if (response.Success) {
                    if (response.ErrorCode) {
                        this.toastr.error(response.Message, "Error");
                    }
                    else {
                        //  this.toastr.success(response.Message, "Success"); 
                    }
                    this.ngOnInit();
                    //this.router.navigate([`/type2`]); 
                    this.activeModal.close("");
                } else {
                    this.toastr.error(this.type2 + " already exists", 'Error');
                }

            });

        this.loadSetting();
    }

    loadSetting() {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));

        this.settingService.getValue("type2", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type2 = response.Data.Value;
                }
            });
    }
    closeModal() {
        this.activeModal.close("");
    };
}



// WEBPACK FOOTER //
// ./src/app/components/custom-type/custom-type-create.component.ts